import { render, staticRenderFns } from "./dateImport.vue?vue&type=template&id=510bc430&"
import script from "./dateImport.vue?vue&type=script&lang=js&"
export * from "./dateImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports